import React from 'react'; 
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import util from '../../../lib/util';
class OffRampSubmitted extends React.Component {

  render() {
  
   const p = this.props;   
    util.trackGoogleAnalytics(p.pageName,'Service address','With offramp');  
    return (
      <div>
          <div className="col-sm-12" >             
             <h3>Thank you!</h3>
                                                
              <p> <div dangerouslySetInnerHTML={{__html: p.message}} /> </p>       
            </div>  
        </div>
    
    );
  }
}

OffRampSubmitted.propTypes = {   
  message : PropTypes.string,
  pageName : PropTypes.string
};

function mapStateToProps(state) {
  return { 
             message : state.gas.reqcall && state.gas.reqcall.message,
             pageName: state.gas.pageName
        };
}

export default connect(mapStateToProps)(OffRampSubmitted);

